import React from "react";
import { Formik } from "formik";
import {
  Container,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";
import { withFirebase } from "../Firebase";

const ContactForm = ({
  values,
  touched,
  errors,
  status,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
}) => (
  <div>
    {status ? (
      <div className="text-success text-center">{status.success}</div>
    ) : (
      <form method="POST" className="contact-form" onSubmit={handleSubmit}>
        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label for="name">Name:</Label>
              <Input
                type="text"
                name="name"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="email">Email:</Label>
              <Input
                type="text"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                className={
                  errors.email && touched.email
                    ? "text-input error"
                    : "text-input"
                }
              />
              {errors.email && touched.email && (
                <div className="input-feedback">{errors.email}</div>
              )}
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <Label for="title">Title:</Label>
          <Input
            type="text"
            name="title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.title}
          />
        </FormGroup>
        <FormGroup>
          <Label for="message">Message:</Label>
          <Input
            type="textarea"
            name="message"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.message}
          />
        </FormGroup>

        <Button
          outline
          color="warning"
          className="submit--rounded"
          type="submit"
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </form>
    )}
  </div>
);

const FormComponent = props => (
  <Container className="main-content">
    <Row className="contact">
      <h1 className="display-5 text-center my-5">
        Thanks for taking the time to reach out. How can I help you today?
      </h1>
      <Col />
      <Col md="8" className="col__main">
        <Formik
          initialValues={{
            name: "",
            email: "",
            title: "",
            message: "",
          }}
          validate={values => {
            const errors = {};
            if (!values.email) {
              errors.email = "*Email is required";
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = "Invalid email address";
            }
            return errors;
          }}
          onSubmit={async (values, actions) => {
            if (values) {
              actions.resetForm();
              actions.setStatus({
                success: "Your email has been submitted successfully!",
              });
            }
            actions.setSubmitting(false);
          }}
          component={ContactForm}
        />
      </Col>
      <Col />
    </Row>
  </Container>
);

const FormWithFirebase = withFirebase(FormComponent);

export default FormWithFirebase;
